// extracted by mini-css-extract-plugin
export default {"cardContainer":"EditDeletePost_cardContainer__pidNk","details":"EditDeletePost_details__Ou3e8"};